module.exports = __webpack_public_path__ + "static/fancy-texture-1abb6e64fdd3602cfa843a1d4f522c62.png";